module.exports = __webpack_public_path__ + "static/img/info1.8cde1df9.svg";